import { useContext } from 'react';
import SurveyContext from './SurveyContext';

const useSurveyContext = () => useContext(SurveyContext);

export default useSurveyContext;
